/* index.js */

"use strict";
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const ButtonControl = uiCore.Control.Action.Button;

module.exports = {
    checkboxFormatter,
    actionButtonsFormatter,
    emailFormatter,
    matchCheckboxFormatter,
    descriptionFormatter,
    nameFormatter,
};

function checkboxFormatter(row, cell, value, columnDef, dataContext) {
    if (columnDef.name === "Compare" && _.get(dataContext, "title", false)) {
        return;
    }

    const isTitle = _.get(dataContext, "title", false);
    const isAvailable = _.get(dataContext, "available", false);
    let el;

    if (isTitle) {
        el = document.createElement("base-icon-gl");
        el.dataset.icon = "common.check";
        el.classList.add(
            "title-block",
            (_.get(dataContext, "category", "") || "").replace(/ /g, "")
        );
        el.setDarkTheme(true);
        const newRoleVal = value || dataContext.newRole;
        dataContext.newRole = newRoleVal;
        if (typeof newRoleVal === "string") {
            switch (newRoleVal) {
                case "some-selected":
                    el.dataset.icon = "common.varied_checked";
                    break;
                case "none-selected":
                    el = document.createElement("span");
                    break;
                case "all-selected":
                    el.dataset.icon = "common.check";
                    break;
            }
        }
    } else {
        el = value ? document.createElement("base-icon-gl") : document.createElement("div");
        if (value) {
            el.dataset.icon = "common.check";
            el.setDarkTheme(true);
        }
        if (!isAvailable) {
            el.classList.add("read-only-block");
        }
    }

    return el.outerHTML;
}

function matchCheckboxFormatter(/*row, cell, value , columnDef, dataContext*/) {
    let checkbox = document.createElement("div");
    return checkbox.outerHTML;
}

function actionButtonsFormatter(/*oSManagementComponent*/) {
    return (row, cell, hasEditRights, columnDef /* , dataContext*/) => {
        const actions = [
            _generateButtons("Edit", "edit", row),
            _generateButtons("Delete", "delete", row, !hasEditRights),
        ];

        columnDef.width = Math.max(columnDef.width, actions.length * 60 + 10);
        return actions.map((btn) => btn.renderer.rootElement.outerHTML).join("");
    };
}

function emailFormatter(row, cell, value, columnDef, dataContext) {
    const description = document.createElement("div");
    if (!_.isEmpty(value)) {
        description.setAttribute("title", value);
    }
    description.classList.add("email-block");
    description.innerText = value || "";

    if (_.get(dataContext, "title", false)) {
        description.classList.add("title-block");
    }

    return description.outerHTML;
}

function _generateButtons(label, action, row, disabled) {
    const btn = new ButtonControl({
        label: label,
        darkTheme: true,
        disabled: disabled,
    });
    btn.setAttribute("role", "button");
    btn.setAttribute("action", action);
    btn.setAttribute("row", row);
    return btn;
}

function descriptionFormatter(row, cell, value, columnDef, dataContext) {
    const description = document.createElement("div");

    if (
        !_.get(dataContext, "title", false) &&
        !(
            _.get(dataContext, "category", "") === "All" &&
            _.get(dataContext, "description", "") === "Global"
        )
    ) {
        description.classList.add("description-column");
    }
    description.innerText = value || "";
    description.setAttribute("title", value);
    return description.outerHTML;
}

function nameFormatter(row, cell, value, columnDef, dataContext) {
    const name = document.createElement("div");

    if (
        !_.get(dataContext, "title", false) &&
        !(
            _.get(dataContext, "category", "") === "All" &&
            _.get(dataContext, "description", "") === "Global"
        )
    ) {
        name.classList.add("name-column");
    }
    name.innerText = value || "";
    name.setAttribute("title", value);
    return name.outerHTML;
}
